class WishlistButton extends HTMLElement {}

customElements.define('wishlist-button', WishlistButton);

var WE_PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
var WE_PRODUCT_CACHE_SHOPIFY_PREFIX = 'we_product_ctx_shopify_';

function weFindVariantRow(variants, lookupId) {
  variants = variants || [];
  lookupId = String(lookupId || '');
  var index;

  for (index = 0; index < variants.length; index += 1) {
    if (String(variants[index].shopify_variant_id) === lookupId) {
      return variants[index];
    }
    if (String(variants[index].variant_id) === lookupId) {
      return variants[index];
    }
  }

  return null;
}

function weGetProductCache(lookupId) {
  lookupId = String(lookupId || '');

  try {
    var raw = sessionStorage.getItem(WE_PRODUCT_CACHE_SHOPIFY_PREFIX + lookupId);

    if (raw) {
      return JSON.parse(raw);
    }

    raw = sessionStorage.getItem(WE_PRODUCT_CACHE_PREFIX + lookupId);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
}

function weCacheProductContext(payload) {
  payload = payload || {};

  try {
    var data = JSON.stringify(payload);

    if (payload.shopify_product_id) {
      sessionStorage.setItem(WE_PRODUCT_CACHE_SHOPIFY_PREFIX + String(payload.shopify_product_id), data);
    }

    if (payload.product_id) {
      sessionStorage.setItem(WE_PRODUCT_CACHE_PREFIX + String(payload.product_id), data);
    }
  } catch (error) {
    /* ignore */
  }
}

function weGetProductAnalyticsFromDom(shopifyProductId) {
  shopifyProductId = String(shopifyProductId || '');
  var selectors;
  var index;
  var node;
  var payload;

  if (!shopifyProductId) {
    return null;
  }

  selectors = [
    'script.webengage-product-analytics[data-product-id="' + shopifyProductId + '"]',
    'script.webengage-wishlist-analytics[data-product-id="' + shopifyProductId + '"]'
  ];

  for (index = 0; index < selectors.length; index += 1) {
    node = document.querySelector(selectors[index]);

    if (!node) {
      continue;
    }

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      /* try next node */
    }
  }

  node = document.getElementById('webengage-product-payload');

  if (node) {
    try {
      payload = JSON.parse(node.textContent || '{}');

      if (String(payload.shopify_product_id) === shopifyProductId) {
        return payload;
      }
    } catch (error) {
      return null;
    }
  }

  return null;
}

function weMergeProductContextFields(cached, domBase) {
  cached = cached || {};
  domBase = domBase || {};
  var merged = {};
  var key;
  var specFields = ['fit', 'sleeve', 'material', 'gender', 'default_color', 'color'];
  var categoryFields = [
    'l1_category_name',
    'l2_category_name',
    'l1_category_id',
    'l2_category_id',
    'product_name',
    'image_url',
    'sub_brand_name',
    'section',
    'view_type'
  ];

  for (key in domBase) {
    if (Object.prototype.hasOwnProperty.call(domBase, key)) {
      merged[key] = domBase[key];
    }
  }

  for (key in cached) {
    if (Object.prototype.hasOwnProperty.call(cached, key)) {
      merged[key] = cached[key];
    }
  }

  specFields.forEach(function (field) {
    if (!merged[field] && domBase[field]) {
      merged[field] = domBase[field];
    }

    if (!merged[field] && cached[field]) {
      merged[field] = cached[field];
    }
  });

  categoryFields.forEach(function (field) {
    if (!merged[field] && cached[field]) {
      merged[field] = cached[field];
    }

    if (!merged[field] && domBase[field]) {
      merged[field] = domBase[field];
    }
  });

  if (!merged.variants || !merged.variants.length) {
    merged.variants = cached.variants || domBase.variants || [];
  }

  return merged;
}

function weGetProductContext(shopifyProductId) {
  var cached = weGetProductCache(shopifyProductId);
  var domBase = weGetProductAnalyticsFromDom(shopifyProductId);

  if (!domBase) {
    return cached || {};
  }

  if (!cached || !cached.product_id) {
    return domBase;
  }

  return weMergeProductContextFields(cached, domBase);
}

function weSeedProductAnalyticsCacheFromDom(root) {
  root = root || document;
  var nodes = root.querySelectorAll(
    'script.webengage-product-analytics[data-product-id], script.webengage-wishlist-analytics[data-product-id]'
  );
  var payloadNode = root.getElementById ? root.getElementById('webengage-product-payload') : null;
  var index;

  for (index = 0; index < nodes.length; index += 1) {
    try {
      weCacheProductContext(JSON.parse(nodes[index].textContent || '{}'));
    } catch (error) {
      /* ignore invalid JSON */
    }
  }

  if (payloadNode) {
    try {
      weCacheProductContext(JSON.parse(payloadNode.textContent || '{}'));
    } catch (error) {
      /* ignore */
    }
  }
}

function weInitProductAnalyticsCacheSeeding() {
  weSeedProductAnalyticsCacheFromDom(document);

  if (!window.MutationObserver) {
    return;
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) {
          return;
        }

        weSeedProductAnalyticsCacheFromDom(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', weInitProductAnalyticsCacheSeeding);
} else {
  weInitProductAnalyticsCacheSeeding();
}

var WE_PRODUCT_ANALYTICS_VIEW = 'webengage-analytics';
var weProductAnalyticsFetchCache = {};

function weShopifyRoot() {
  return typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
}

function weProductHandleFromUrl(url) {
  var match = String(url || '').match(/\/products\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}

function weCartItemHandle(item) {
  item = item || {};

  if (item.handle) {
    return String(item.handle).trim();
  }

  return weProductHandleFromUrl(item.url || '');
}

function weFetchProductAnalyticsByHandle(handle) {
  handle = String(handle || '').trim();

  if (!handle) {
    return Promise.resolve(null);
  }

  if (weProductAnalyticsFetchCache[handle]) {
    return weProductAnalyticsFetchCache[handle];
  }

  var root = weShopifyRoot();

  if (root.charAt(root.length - 1) !== '/') {
    root += '/';
  }

  var promise = fetch(root + 'products/' + encodeURIComponent(handle) + '?view=' + WE_PRODUCT_ANALYTICS_VIEW, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json, text/plain, */*' }
  })
    .then(function (response) {
      if (!response.ok) {
        return null;
      }

      return response.text();
    })
    .then(function (text) {
      if (!text) {
        return null;
      }

      try {
        var parsed = JSON.parse(text.trim());

        if (parsed && (parsed.shopify_product_id || parsed.product_id)) {
          weCacheProductContext(parsed);
        }

        return parsed;
      } catch (error) {
        return null;
      }
    })
    .catch(function () {
      return null;
    });

  weProductAnalyticsFetchCache[handle] = promise;
  return promise;
}

function weNormalizeImageUrl(url) {
  url = String(url || '').trim();

  if (!url) {
    return '';
  }

  if (url.indexOf('//') === 0) {
    return 'https:' + url;
  }

  return url;
}

function weNormalizeProductPricing(mrp, totalPayable, discount) {
  mrp = Number(mrp) || 0;
  totalPayable = Number(totalPayable) || 0;
  discount = Number(discount);
  if (isNaN(discount) || (discount === 0 && mrp > totalPayable)) {
    discount = mrp > totalPayable ? mrp - totalPayable : 0;
  }

  return {
    mrp: mrp,
    total_payable: totalPayable,
    discount_on_mrp: discount
  };
}

function weGetUsableProductCategories(source) {
  source = source || {};
  var l1 = source.l1_category_name || '';
  var l2 = source.l2_category_name || '';

  if (String(l1).trim().toLowerCase() === 'all products') {
    l1 = '';
  }

  if (String(l2).trim().toLowerCase() === 'all products') {
    l2 = '';
  }

  return {
    l1_category_name: l1,
    l2_category_name: l2,
    l1_category_id: l1 ? String(source.l1_category_id || '') : '',
    l2_category_id: l2 ? String(source.l2_category_id || '') : ''
  };
}

var WE_PLP_BROWSE_CATEGORY_KEY = 'we_plp_browse_category_context';

function weParseCollectionHandleFromUrl(url) {
  var match = String(url || '').match(/\/collections\/([^/?#]+)/);
  return match ? match[1] : '';
}

function weGetPlpBrowseCategoryContext() {
  try {
    var raw = sessionStorage.getItem(WE_PLP_BROWSE_CATEGORY_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

function weSetPlpBrowseCategoryContext(context) {
  try {
    sessionStorage.setItem(WE_PLP_BROWSE_CATEGORY_KEY, JSON.stringify(context || {}));
  } catch (error) {
    /* ignore */
  }
}

function weNormalizeHandleList(handles) {
  if (!handles) {
    return [];
  }

  if (Array.isArray(handles)) {
    return handles.map(function (handle) {
      return String(handle || '').trim();
    }).filter(Boolean);
  }

  return [];
}

function weIsFilterCategoryNavigation(referrerHandle, currentHandle, stored) {
  referrerHandle = String(referrerHandle || '');
  currentHandle = String(currentHandle || '');
  var navigableHandles;

  if (!referrerHandle || !currentHandle || referrerHandle === currentHandle) {
    return false;
  }

  if (!stored || !stored.root_l1_category_name || stored.collection_handle !== referrerHandle) {
    return false;
  }

  navigableHandles = weNormalizeHandleList(stored.navigable_collection_handles);

  if (!navigableHandles.length) {
    return true;
  }

  return navigableHandles.indexOf(currentHandle) !== -1;
}

function weResolveBrowseCategoryPayload(menuPayload) {
  menuPayload = menuPayload || {};
  var stored = weGetPlpBrowseCategoryContext();
  var currentId = String(menuPayload.id || '');
  var currentHandle = String(menuPayload.handle || '');
  var currentName = String(menuPayload.name || '');
  var referrerHandle = weParseCollectionHandleFromUrl(document.referrer || '');
  var navigableHandles = weNormalizeHandleList(menuPayload.navigable_collection_handles);
  var menuCategories = weGetUsableProductCategories(menuPayload);
  var result;
  var nextContext;

  if (stored && stored.collection_id === currentId) {
    result = {
      l1_category_name: stored.root_l1_category_name || stored.l1_category_name || '',
      l2_category_name: stored.l2_category_name || '',
      l1_category_id: String(stored.root_l1_category_id || stored.l1_category_id || ''),
      l2_category_id: String(stored.l2_category_id || '')
    };
  } else if (weIsFilterCategoryNavigation(referrerHandle, currentHandle, stored)) {
    result = {
      l1_category_name: stored.root_l1_category_name,
      l2_category_name: currentName,
      l1_category_id: String(stored.root_l1_category_id || ''),
      l2_category_id: currentId
    };
  } else {
    result = {
      l1_category_name: menuCategories.l1_category_name || currentName,
      l2_category_name: menuCategories.l2_category_name || menuPayload.l2_category_name || '',
      l1_category_id: String(
        menuCategories.l1_category_name ? (menuPayload.l1_category_id || currentId) : ''
      ),
      l2_category_id: String(
        menuCategories.l2_category_name || menuPayload.l2_category_name
          ? (menuPayload.l2_category_id || '')
          : ''
      )
    };
  }

  nextContext = {
    root_l1_category_name: result.l1_category_name,
    root_l1_category_id: result.l1_category_id,
    l1_category_name: result.l1_category_name,
    l2_category_name: result.l2_category_name,
    l1_category_id: result.l1_category_id,
    l2_category_id: result.l2_category_id,
    collection_id: currentId,
    collection_handle: currentHandle,
    navigable_collection_handles: navigableHandles
  };

  if (weIsFilterCategoryNavigation(referrerHandle, currentHandle, stored)) {
    nextContext.root_l1_category_name = stored.root_l1_category_name;
    nextContext.root_l1_category_id = stored.root_l1_category_id;
    nextContext.l1_category_name = stored.root_l1_category_name;
    nextContext.l1_category_id = stored.root_l1_category_id;
  }

  weSetPlpBrowseCategoryContext(nextContext);
  return result;
}

function weApplyBrowseCategoryToProductPayload(payload, options) {
  payload = payload || {};
  options = options || {};
  var context = weGetPlpBrowseCategoryContext();

  if (!context || !context.root_l1_category_name) {
    return payload;
  }

  var section = options.section || payload.section || '';
  var onCollectionPath = window.location.pathname.indexOf('/collections/') !== -1;
  var fromCollection = !!weParseCollectionHandleFromUrl(document.referrer || '');

  if (section === 'PLP' || onCollectionPath || fromCollection) {
    payload.l1_category_name = context.root_l1_category_name;
    payload.l1_category_id = String(context.root_l1_category_id || '');
    payload.l2_category_name = context.l2_category_name || '';
    payload.l2_category_id = String(context.l2_category_id || '');
  }

  return payload;
}

var WE_MULTI_PRODUCT_STRING_FIELDS = [
  'product_id',
  'product_name',
  'variant_id',
  'sub_brand_name',
  'l1_category_name',
  'l2_category_name',
  'l1_category_id',
  'l2_category_id',
  'color',
  'fit',
  'sleeve',
  'material',
  'gender',
  'size',
  'image_url'
];

function weAggregateProductDetailField(details, field) {
  var values = [];

  (details || []).forEach(function (item) {
    if (item[field]) {
      values.push(String(item[field]));
    }
  });

  return values.filter(function (value, index) {
    return values.indexOf(value) === index;
  }).join(', ');
}

function weApplyAggregatedProductFields(target, details, fields) {
  target = target || {};
  fields = fields || WE_MULTI_PRODUCT_STRING_FIELDS;

  fields.forEach(function (field) {
    target[field] = weAggregateProductDetailField(details, field);
  });

  return target;
}

document.addEventListener('variant:change', function (event) {
  var variant = event.detail && event.detail.variant;
  if (!variant || !variant.id) return;

  document.querySelectorAll('wishlist-button').forEach(function (button) {
    button.dataset.variantId = String(variant.id);
  });
});

(function () {
  var WISHLIST_API_BASE = 'https://livewishlist.scriptengine.net/api';
  var WISHLIST_STORE_ID_KEY = 'we_wishlist_store_id';
  var lastWishlistViewedAt = 0;
  var lastWishlistActionKey = '';
  var lastWishlistActionAt = 0;
  var WISHLIST_ENRICH_TIMEOUT_MS = 3500;

  function weShopifyRoot() {
    return typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function weWishlistItemHandle(item) {
    item = item || {};
    var handle = item.handle || item.product_handle || item.slug || '';

    if (handle) {
      return String(handle).trim();
    }

    var url = item.product_url || item.url || item.link || '';
    var match = String(url).match(/\/products\/([^/?#]+)/);

    return match ? decodeURIComponent(match[1]) : '';
  }

  function wishlistMappedLineComplete(mapped) {
    mapped = mapped || {};
    return String(mapped.product_id || '').trim() && String(mapped.variant_id || '').trim();
  }

  function wishlistItemNeedsEnrichment(item) {
    item = item || {};
    var shopifyProductId = String(item.shopify_id || item.product_id || '');
    var shopifyVariantId = String(item.shopify_variant_id || item.variant_id || '');
    var cached = weGetProductContext(shopifyProductId);
    var variantRow = weFindVariantRow(cached.variants, shopifyVariantId);

    return !wishlistMappedLineComplete({
      product_id: String(cached.product_id || ''),
      variant_id: String((variantRow && variantRow.variant_id) || item.sku || '')
    });
  }

  function fetchWishlistProductAnalyticsByHandle(handle) {
    return weFetchProductAnalyticsByHandle(handle);
  }

  function enrichWishlistItems(items, callback) {
    items = items || [];
    var handlesToFetch = {};
    var handles = [];
    var index;
    var handle;
    var done = false;

    function finish() {
      if (done) {
        return;
      }

      done = true;
      callback(items);
    }

    for (index = 0; index < items.length; index += 1) {
      if (wishlistItemNeedsEnrichment(items[index])) {
        handle = weWishlistItemHandle(items[index]);

        if (handle && !handlesToFetch[handle]) {
          handlesToFetch[handle] = true;
          handles.push(handle);
        }
      }
    }

    if (!handles.length) {
      finish();
      return;
    }

    var timeoutId = setTimeout(finish, WISHLIST_ENRICH_TIMEOUT_MS);

    Promise.all(
      handles.map(function (itemHandle) {
        return fetchWishlistProductAnalyticsByHandle(itemHandle);
      })
    )
      .then(function () {
        clearTimeout(timeoutId);
        finish();
      })
      .catch(function () {
        clearTimeout(timeoutId);
        finish();
      });
  }

  function getWishlistCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie.split(';');

    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(part.substring(prefix.length));
        } catch (error) {
          return part.substring(prefix.length);
        }
      }
    }

    return '';
  }

  function getWishlistCustomerRecords() {
    var node = document.getElementById('wishlist-engine-customer-records');

    try {
      return JSON.parse((node && node.textContent) || '{}');
    } catch (error) {
      return {};
    }
  }

  function publishAnalyticsEvent(eventName, payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish(eventName, payload);
  }

  function getWishlistTotalFromDom() {
    var node = document.querySelector('.wishlist-total-count');
    var total;

    if (node) {
      total = parseInt(node.getAttribute('data-total') || node.textContent, 10);
      if (!isNaN(total)) {
        return total;
      }
    }

    total = parseInt(getWishlistCookie('WISHLIST_TOTAL'), 10);
    return isNaN(total) ? 0 : total;
  }

  function buildWishlistRequestBody(extra) {
    var records = getWishlistCustomerRecords();
    var body = {
      uuid: getWishlistCookie('WISHLIST_UUID') || '',
      ip_address: getWishlistCookie('WISHLIST_IP_ADDRESS') || '',
      customer_id: records.id || '',
      customers: records,
      shopify_store_id: sessionStorage.getItem(WISHLIST_STORE_ID_KEY) || '',
      shopify_store: typeof Shopify !== 'undefined' ? Shopify.shop : '',
      search: '',
      active_currency: (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) || '',
      share_id: '',
      shopify_local_language: (typeof Shopify !== 'undefined' && Shopify.locale) || 'en'
    };

    if (extra) {
      Object.keys(extra).forEach(function (key) {
        body[key] = extra[key];
      });
    }

    return body;
  }

  function wishlistApiPost(path, body) {
    return fetch(WISHLIST_API_BASE + path, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json();
    });
  }

  function ensureWishlistStoreId(callback) {
    var cached = sessionStorage.getItem(WISHLIST_STORE_ID_KEY);

    if (cached) {
      callback(cached);
      return;
    }

    wishlistApiPost('/apps-config', buildWishlistRequestBody({ shop: typeof Shopify !== 'undefined' ? Shopify.shop : '' }))
      .then(function (response) {
        var storeId = response && response.data && response.data.id ? String(response.data.id) : '';

        if (storeId) {
          sessionStorage.setItem(WISHLIST_STORE_ID_KEY, storeId);
        }

        callback(storeId);
      })
      .catch(function () {
        callback('');
      });
  }

  function mapWishlistApiItem(item) {
    item = item || {};
    var shopifyProductId = String(item.shopify_id || item.product_id || '');
    var shopifyVariantId = String(item.shopify_variant_id || item.variant_id || '');
    var cached = weGetProductContext(shopifyProductId);
    var variantRow = weFindVariantRow(cached.variants, shopifyVariantId);
    var categories = weGetUsableProductCategories(cached);
    var variants = item.variants || {};
    var variant = variants[shopifyVariantId] || variants[item.shopify_variant_id] || {};
    var price = Number(variant.price || item.price || 0);
    var compareAt = Number(variant.compare_at_price || variant.compare_at || price);
    var lineDiscount = compareAt > price ? compareAt - price : 0;
    var mrp = Number((variantRow && variantRow.mrp) || cached.mrp) || compareAt;
    var totalPayable = Number((variantRow && variantRow.total_payable) || cached.total_payable) || price;
    var discountSource = variantRow && variantRow.discount_on_mrp != null && variantRow.discount_on_mrp !== ''
      ? variantRow.discount_on_mrp
      : cached.discount_on_mrp;
    var discountVal = discountSource != null && discountSource !== ''
      ? Number(discountSource)
      : lineDiscount;
    var pricing = weNormalizeProductPricing(mrp, totalPayable, discountVal);
    var quantity = Number(item.quntity || item.quantity || 1);

    if (isNaN(quantity) || quantity <= 0) {
      quantity = 1;
    }

    return {
      product_id: String(cached.product_id || ''),
      product_name: cached.product_name || item.title || item.product_name || '',
      variant_id: String((variantRow && variantRow.variant_id) || item.sku || ''),
      image_url: variant.image_src || item.image || cached.image_url || '',
      sub_brand_name: cached.sub_brand_name || item.vendor || '',
      l1_category_name: categories.l1_category_name,
      l2_category_name: categories.l2_category_name,
      l1_category_id: categories.l1_category_id,
      l2_category_id: categories.l2_category_id,
      mrp: pricing.mrp,
      discount_on_mrp: pricing.discount_on_mrp,
      total_payable: pricing.total_payable,
      in_stock: variantRow ? !!variantRow.in_stock : (cached.in_stock !== undefined ? !!cached.in_stock : true),
      color: (variantRow && variantRow.color) || cached.color || '',
      fit: cached.fit || '',
      sleeve: cached.sleeve || '',
      material: cached.material || '',
      gender: cached.gender || '',
      size: (variantRow && variantRow.size) || cached.size || '',
      section: cached.section || '',
      view_type: cached.view_type || 'normal',
      quantity: quantity
    };
  }

  function mapWishlistActionPayload(product) {
    if (!product) {
      return null;
    }

    var shopifyProductId = String(product.shopify_id || product.product_id || product.id || '');
    var shopifyVariantId = String(product.shopify_variant_id || product.variant_id || product.variant || '');
    var cached = weGetProductContext(shopifyProductId);
    var payload = mapWishlistApiItem({
      shopify_id: shopifyProductId,
      shopify_variant_id: shopifyVariantId,
      title: product.title || product.product_name || product.name,
      product_name: product.product_name || product.name,
      sku: product.sku,
      price: product.price,
      compare_at_price: product.compare_at_price || product.compare_at,
      vendor: product.vendor,
      image: product.image || product.image_src,
      quantity: product.quntity || product.quantity || 1,
      variants: product.variants || {}
    });

    payload.shopify_product_id = shopifyProductId;
    payload.shopify_variant_id = shopifyVariantId;
    payload.variants = (cached && cached.variants) || [];
    return payload;
  }

  function mapWishlistCallbackProduct(product) {
    var payload = mapWishlistActionPayload(product);

    if (!payload) {
      return null;
    }

    return {
      product_id: payload.product_id,
      product_name: payload.product_name,
      variant_id: payload.variant_id
    };
  }

  function buildWishlistSummary(items, meta) {
    var productDetails = [];
    var subtotal = 0;
    var index;

    items = items || [];
    meta = meta || {};

    for (index = 0; index < items.length; index += 1) {
      var mapped = mapWishlistApiItem(items[index]);

      if (!wishlistMappedLineComplete(mapped)) {
        continue;
      }

      productDetails.push(mapped);
      subtotal += mapped.total_payable * (mapped.quantity || 1);
    }

    subtotal = Math.round(subtotal * 100) / 100;

    var totalCount = productDetails.length || Number(meta.total_items_in_wishlist);
    if (isNaN(totalCount)) {
      totalCount = productDetails.length;
    }

    var summary = {
      total_items_in_wishlist: totalCount,
      subtotal: subtotal,
      total_payable: subtotal,
      product_details: productDetails
    };

    weApplyAggregatedProductFields(summary, productDetails);

    if (meta.action) {
      summary.action = meta.action;
    }

    return summary;
  }

  function fetchWishlistItems(callback) {
    ensureWishlistStoreId(function (storeId) {
      var body = buildWishlistRequestBody();
      body.shopify_store_id = storeId;

      wishlistApiPost('/apps-wishlist', body)
        .then(function (response) {
          callback((response && response.data) || []);
        })
        .catch(function () {
          wishlistApiPost('/get-all-product', body)
            .then(function (fallbackResponse) {
              callback((fallbackResponse && fallbackResponse.data) || []);
            })
            .catch(function () {
              callback([]);
            });
        });
    });
  }

  function publishWishlistAnalyticsEvent(eventName, items, meta) {
    enrichWishlistItems(items, function (enrichedItems) {
      publishAnalyticsEvent(eventName, buildWishlistSummary(enrichedItems, meta));
    });
  }

  function publishWishlistUpdated(action, changedProduct) {
    fetchWishlistItems(function (items) {
      var meta = {
        action: action,
        total_items_in_wishlist: getWishlistTotalFromDom() || items.length
      };

      if (changedProduct) {
        meta.product_id = changedProduct.product_id;
        meta.product_name = changedProduct.product_name;
        meta.variant_id = changedProduct.variant_id;
      }

      publishWishlistAnalyticsEvent('bestseller:wishlist_updated', items, meta);
    });
  }

  function publishWishlistViewed() {
    var now = Date.now();

    if (now - lastWishlistViewedAt < 2000) {
      return;
    }

    fetchWishlistItems(function (items) {
      lastWishlistViewedAt = Date.now();
      publishWishlistAnalyticsEvent('bestseller:wishlist_viewed', items, {
        total_items_in_wishlist: getWishlistTotalFromDom() || items.length
      });
    });
  }

  function isWishlistPage() {
    var path = window.location.pathname;
    return path === '/pages/wishlist' || path.indexOf('/apps/wishlist') === 0;
  }

  function initWishlistPageViewTracking() {
    if (!isWishlistPage()) {
      return;
    }

    var published = false;

    function schedulePublish() {
      if (published) {
        return;
      }

      published = true;
      setTimeout(publishWishlistViewed, 800);
    }

    var observer = new MutationObserver(function () {
      var container = document.querySelector('.wishlistajaxLoad, .wishlist-row');

      if (
        container &&
        container.querySelector('[id^="wishlist_page_"], .wh-list-column, .wh-grid-column, .wishlsitnoitem')
      ) {
        schedulePublish();
      }
    });

    var page = document.querySelector('.wishlist-page');

    if (page) {
      observer.observe(page, { childList: true, subtree: true });
    }

    setTimeout(schedulePublish, 2500);
  }

  function shouldPublishWishlistAction(action, payload) {
    if (!payload) {
      return false;
    }

    var key =
      action +
      ':' +
      String(payload.shopify_product_id || payload.product_id || '') +
      ':' +
      String(payload.shopify_variant_id || payload.variant_id || '');
    var now = Date.now();

    if (key && key === lastWishlistActionKey && now - lastWishlistActionAt < 3000) {
      return false;
    }

    lastWishlistActionKey = key;
    lastWishlistActionAt = now;
    return true;
  }

  window.wishlistCallback = function (data) {
    data = data || {};
    var actionMap = {
      ADD: 'add',
      REMOVE: 'remove',
      MOVETOCART: 'move_to_cart'
    };
    var action = actionMap[data.event] || String(data.event || '').toLowerCase();
    var actionPayload = mapWishlistActionPayload(data.product);

    if (action === 'add' && shouldPublishWishlistAction('add', actionPayload)) {
      publishAnalyticsEvent('add_to_wishlist', actionPayload);
    } else if (action === 'remove' && shouldPublishWishlistAction('remove', actionPayload)) {
      publishAnalyticsEvent('remove_from_wishlist', actionPayload);
    }

    if (action === 'move_to_cart' && typeof window.wePublishCartUpdatedFromFetch === 'function') {
      setTimeout(function () {
        window.wePublishCartUpdatedFromFetch({ action: 'add' });
      }, 400);
    }

    setTimeout(function () {
      publishWishlistUpdated(action, mapWishlistCallbackProduct(data.product));
    }, 300);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPageViewTracking);
  } else {
    initWishlistPageViewTracking();
  }
})();

(function () {
  var PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
  var PRODUCT_CACHE_SHOPIFY_PREFIX = 'we_product_ctx_shopify_';

  function findVariantRow(variants, lookupId) {
    variants = variants || [];
    lookupId = String(lookupId || '');
    var index;

    for (index = 0; index < variants.length; index += 1) {
      if (String(variants[index].shopify_variant_id) === lookupId) {
        return variants[index];
      }
      if (String(variants[index].variant_id) === lookupId) {
        return variants[index];
      }
    }

    return null;
  }

  function getThemeProductCache(productId) {
    productId = String(productId || '');

    try {
      var raw = sessionStorage.getItem(PRODUCT_CACHE_SHOPIFY_PREFIX + productId);

      if (raw) {
        return JSON.parse(raw);
      }

      raw = sessionStorage.getItem(PRODUCT_CACHE_PREFIX + productId);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function centsToAmount(cents) {
    return Number(cents || 0) / 100;
  }

  function normalizeProductPricing(mrp, totalPayable, discount) {
    mrp = Number(mrp) || 0;
    totalPayable = Number(totalPayable) || 0;
    discount = Number(discount);
    if (isNaN(discount) || (discount === 0 && mrp > totalPayable)) {
      discount = mrp > totalPayable ? mrp - totalPayable : 0;
    }

    return {
      mrp: mrp,
      total_payable: totalPayable,
      discount_on_mrp: discount
    };
  }

  function mapCartLineForCheckout(item) {
    item = item || {};
    var cached = weGetProductContext(item.product_id);
    var variantRow = findVariantRow(cached.variants, item.variant_id);
    var price = centsToAmount(item.final_price || item.price);
    var compareAt = centsToAmount(item.original_price || item.price);
    var lineDiscount = compareAt > price ? compareAt - price : 0;
    var mrp = Number((variantRow && variantRow.mrp) || cached.mrp) || compareAt;
    var totalPayable = Number((variantRow && variantRow.total_payable) || cached.total_payable) || price;
    var discountSource = variantRow && variantRow.discount_on_mrp != null && variantRow.discount_on_mrp !== ''
      ? variantRow.discount_on_mrp
      : cached.discount_on_mrp;
    var discountVal = discountSource != null && discountSource !== ''
      ? Number(discountSource)
      : lineDiscount;
    var pricing = normalizeProductPricing(mrp, totalPayable, discountVal);

    return {
      product_id: String(cached.product_id || ''),
      product_name: item.product_title || cached.product_name || '',
      variant_id: String((variantRow && variantRow.variant_id) || item.sku || ''),
      image_url: weNormalizeImageUrl(item.image || item.featured_image || cached.image_url || ''),
      sub_brand_name: item.vendor || cached.sub_brand_name || '',
      l1_category_name: cached.l1_category_name || '',
      l2_category_name: cached.l2_category_name || '',
      l1_category_id: String(cached.l1_category_id || ''),
      l2_category_id: String(cached.l2_category_id || ''),
      mrp: pricing.mrp,
      discount_on_mrp: pricing.discount_on_mrp,
      total_payable: pricing.total_payable,
      in_stock: variantRow
        ? !!variantRow.in_stock
        : cached.in_stock !== undefined
          ? !!cached.in_stock
          : true,
      color: (variantRow && variantRow.color) || cached.color || cached.default_color || '',
      fit: cached.fit || '',
      sleeve: cached.sleeve || '',
      material: cached.material || '',
      gender: cached.gender || '',
      size: (variantRow && variantRow.size) || cached.size || item.variant_title || '',
      quantity: Number(item.quantity) || 1
    };
  }

  var CART_ENRICH_TIMEOUT_MS = 3500;

  function cartItemNeedsEnrichment(item) {
    item = item || {};
    var cached = weGetProductContext(item.product_id);
    var variantRow = findVariantRow(cached.variants, item.variant_id);

    if (!String(cached.product_id || '').trim()) {
      return true;
    }

    return !variantRow;
  }

  function enrichCartItems(items, callback) {
    items = items || [];
    var handlesToFetch = {};
    var handles = [];
    var index;
    var handle;
    var done = false;

    function finish() {
      if (done) {
        return;
      }

      done = true;
      callback(items);
    }

    for (index = 0; index < items.length; index += 1) {
      if (cartItemNeedsEnrichment(items[index])) {
        handle = weCartItemHandle(items[index]);

        if (handle && !handlesToFetch[handle]) {
          handlesToFetch[handle] = true;
          handles.push(handle);
        }
      }
    }

    if (!handles.length) {
      finish();
      return;
    }

    var timeoutId = setTimeout(finish, CART_ENRICH_TIMEOUT_MS);

    Promise.all(
      handles.map(function (itemHandle) {
        return weFetchProductAnalyticsByHandle(itemHandle);
      })
    )
      .then(function () {
        clearTimeout(timeoutId);
        finish();
      })
      .catch(function () {
        clearTimeout(timeoutId);
        finish();
      });
  }

  function publishCartPayload(eventName, cart, changedLine, payloadMutator) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    if (!cart || !Array.isArray(cart.items)) {
      return;
    }

    enrichCartItems(cart.items, function () {
      var payload = buildCartSummaryFromCart(cart, changedLine);

      if (typeof payloadMutator === 'function') {
        payloadMutator(payload);
      }

      Shopify.analytics.publish(eventName, payload);
    });
  }

  var lastCartLinesByKey = {};

  function snapshotCartLines(cart) {
    var map = {};
    var items = (cart && cart.items) || [];
    var i;
    var item;
    var key;

    for (i = 0; i < items.length; i += 1) {
      item = items[i];
      key = String(item.key || item.variant_id || item.id || i);
      map[key] = item;
    }

    return map;
  }

  function findChangedCartLine(cart) {
    var items = (cart && cart.items) || [];
    var next = snapshotCartLines(cart);
    var i;
    var item;
    var key;
    var prev;
    var changed = null;

    for (i = 0; i < items.length; i += 1) {
      item = items[i];
      key = String(item.key || item.variant_id || item.id || i);
      prev = lastCartLinesByKey[key];

      if (!prev || Number(prev.quantity) !== Number(item.quantity)) {
        changed = item;
        break;
      }
    }

    if (!changed) {
      for (key in lastCartLinesByKey) {
        if (!Object.prototype.hasOwnProperty.call(lastCartLinesByKey, key)) {
          continue;
        }

        if (!next[key]) {
          changed = lastCartLinesByKey[key];
          break;
        }
      }
    }

    lastCartLinesByKey = next;
    return changed || items[0] || null;
  }

  function getCheckoutItemsCount(details, fallback) {
    var total = 0;

    (details || []).forEach(function (item) {
      total += Number(item.quantity) || 1;
    });

    if (total) {
      return total;
    }

    return Number(fallback) || 0;
  }

  function getCartDiscountBreakdown(cart) {
    cart = cart || {};
    var apps = cart.cart_level_discount_applications || [];
    var couponNames = [];
    var appCouponValue = 0;
    var promoNames = [];
    var appPromoValue = 0;
    var allocationCouponValue = 0;
    var allocationPromoValue = 0;
    var index;

    for (index = 0; index < apps.length; index += 1) {
      var app = apps[index];
      var title = app.title || '';
      var amount = centsToAmount(app.total_allocated_amount || 0);
      var type = String(app.type || '').toLowerCase();

      if (type === 'discount_code' || type === 'code') {
        if (title) {
          couponNames.push(title);
        }
        appCouponValue += amount;
      } else {
        if (title) {
          promoNames.push(title);
        }
        appPromoValue += amount;
      }
    }

    (cart.items || []).forEach(function (item) {
      var allocations = item.line_level_discount_allocations || item.discount_allocations || [];

      allocations.forEach(function (allocation) {
        var discountApp = allocation.discount_application || allocation.discountApplication || {};
        var value = centsToAmount(allocation.amount || 0);
        var discountType = String(discountApp.type || '').toLowerCase();
        var discountTitle = discountApp.title || '';

        if (discountType === 'discount_code' || discountType === 'code') {
          if (discountTitle && couponNames.indexOf(discountTitle) === -1) {
            couponNames.push(discountTitle);
          }
          allocationCouponValue += value;
        } else {
          if (discountTitle && promoNames.indexOf(discountTitle) === -1) {
            promoNames.push(discountTitle);
          }
          allocationPromoValue += value;
        }
      });
    });

    var couponValue = allocationCouponValue > 0 ? allocationCouponValue : appCouponValue;
    var promoValue = allocationPromoValue > 0 ? allocationPromoValue : appPromoValue;
    var totalDiscount = centsToAmount(cart.total_discount || 0);

    if (totalDiscount > 0 && couponValue === 0 && promoValue === 0) {
      if (promoNames.length) {
        promoValue = totalDiscount;
      } else if (couponNames.length) {
        couponValue = totalDiscount;
      } else {
        promoValue = totalDiscount;
      }
    }

    return {
      coupon_name: couponNames.join(', '),
      coupon_value: couponValue,
      promotion_name: promoNames.join(', '),
      promotion_value: promoValue
    };
  }

  function buildCheckoutPayloadFromCart(cart) {
    cart = cart || {};
    var items = cart.items || [];
    var productDetails = items.map(mapCartLineForCheckout);
    var discounts = getCartDiscountBreakdown(cart);
    var subtotal = centsToAmount(cart.items_subtotal_price);
    var totalPayable = centsToAmount(cart.total_price);
    var tax = 0;

    if (cart.total_tax != null && cart.total_tax !== '') {
      tax = centsToAmount(cart.total_tax);
    } else if (totalPayable > subtotal) {
      tax = totalPayable - subtotal;
    }

    var payload = {
      cart_id: String(cart.token || ''),
      total_items_in_cart: getCheckoutItemsCount(productDetails, cart.item_count),
      subtotal: subtotal,
      tax: tax,
      total_payable: totalPayable,
      coupon_name: discounts.coupon_name,
      coupon_value: discounts.coupon_value,
      promotion_name: discounts.promotion_name,
      promotion_value: discounts.promotion_value,
      checkout_url: '',
      product_details: productDetails
    };

    weApplyAggregatedProductFields(payload, productDetails);
    return payload;
  }

  function publishCheckoutInitiatedFromCart() {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        enrichCartItems((cart && cart.items) || [], function () {
          Shopify.analytics.publish('bestseller:checkout_initiated', buildCheckoutPayloadFromCart(cart));
        });
      })
      .catch(function () {});
  }

  function buildCartSummaryFromCart(cart, changedLine) {
    cart = cart || {};
    var items = cart.items || [];
    var productDetails = items.map(mapCartLineForCheckout);
    var subtotal = centsToAmount(cart.items_subtotal_price);
    var totalPayable = centsToAmount(cart.total_price);
    var tax = 0;
    var payload;

    if (cart.total_tax != null && cart.total_tax !== '') {
      tax = centsToAmount(cart.total_tax);
    } else if (totalPayable > subtotal) {
      tax = totalPayable - subtotal;
    }

    payload = {
      total_items_in_cart: Number(cart.item_count) || 0,
      subtotal: subtotal,
      tax: tax,
      total_payable: totalPayable,
      product_details: productDetails
    };

    weApplyAggregatedProductFields(payload, productDetails);
    return payload;
  }

  function publishCartAnalyticsEvent(eventName, cart) {
    publishCartPayload(eventName, cart, cart.items[0] || null);
  }

  function publishCartUpdatedFromFetch(options) {
    options = options || {};

    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        publishCartPayload('bestseller:cart_updated', cart, findChangedCartLine(cart), function (payload) {
          if (options.action) {
            payload.action = options.action;
          }
        });
      })
      .catch(function () {});
  }

  window.wePublishCartUpdatedFromFetch = publishCartUpdatedFromFetch;

  function fetchAndPublishCartAnalytics(eventName) {
    fetch((Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (response) {
          return response.json();
        })
      .then(function (cart) {
        if (eventName === 'bestseller:cart_updated') {
          publishCartPayload(eventName, cart, findChangedCartLine(cart));
          return;
        }

        publishCartAnalyticsEvent(eventName, cart);
      })
      .catch(function () {});
  }

  var lastCartViewedAt = 0;

  function publishCartViewed(cart) {
    var now = Date.now();

    if (now - lastCartViewedAt < 2000) {
      return;
    }

    lastCartViewedAt = now;

    if (cart && Array.isArray(cart.items)) {
      publishCartAnalyticsEvent('bestseller:cart_viewed', cart);
      return;
    }

    fetchAndPublishCartAnalytics('bestseller:cart_viewed');
  }

  function getCartActionFromBaseEvent(baseEvent) {
    if (baseEvent === 'variant:add') {
      return 'add';
    }

    if (baseEvent === 'line-item:change') {
      return 'update';
    }

    return '';
  }

  document.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    var cart = detail.cart;

    if (!cart || !Array.isArray(cart.items)) {
      fetchAndPublishCartAnalytics('bestseller:cart_updated');
      return;
    }

    publishCartPayload('bestseller:cart_updated', cart, findChangedCartLine(cart), function (payload) {
      var action = getCartActionFromBaseEvent(detail.baseEvent);

      if (action) {
        payload.action = action;
      }
    });
  });

  window.addEventListener('view_cart', function () {
    publishCartViewed();
  });

  function initCartPageViewTracking() {
    var path = window.location.pathname;

    if (path !== '/cart' && path.indexOf('/cart/') !== 0) {
      return;
    }

    setTimeout(function () {
      publishCartViewed();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPageViewTracking);
  } else {
    initCartPageViewTracking();
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');

      if (!target) {
        return;
      }

      if (target.tagName === 'A' && target.href && target.href.indexOf('/checkout') === -1) {
        return;
      }

      publishCheckoutInitiatedFromCart();
    },
    true
  );
})();

(function () {
  var lastProductSearchedKey = '';

  function publishProductSearchedEvent(payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish('bestseller:product_searched', payload);
  }

  function getSearchTermFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return (params.get('q') || params.get('query') || '').trim();
    } catch (error) {
      return '';
    }
  }

  function getProductCountFromTitle() {
    var title = document.title || '';
    var match = title.match(/(\d+)\s+results?\s+found/i);

    if (!match) {
      return null;
    }

    return parseInt(match[1], 10);
  }

  function isSearchPage() {
    var path = window.location.pathname;
    return path === '/search' || path.indexOf('/search/') === 0;
  }

  function shouldSkipProductSearched(searchTerm) {
    var key = String(searchTerm).toLowerCase();

    if (lastProductSearchedKey === key) {
      return true;
    }

    lastProductSearchedKey = key;
    return false;
  }

  function publishProductSearchedFromSearchPage() {
    if (!isSearchPage()) {
      return false;
    }

    var searchTerm = getSearchTermFromUrl();
    var productCount = getProductCountFromTitle();

    if (!searchTerm || productCount === null || isNaN(productCount)) {
      return false;
    }

    if (shouldSkipProductSearched(searchTerm)) {
      return true;
    }

    publishProductSearchedEvent({
      search_term: searchTerm,
      product_count: productCount
    });

    return true;
  }

  function initSearchPageTracking() {
    if (!isSearchPage()) {
      return;
    }

    if (publishProductSearchedFromSearchPage()) {
      return;
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;

      if (publishProductSearchedFromSearchPage() || attempts >= 8) {
        window.clearInterval(interval);
      }
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPageTracking);
  } else {
    initSearchPageTracking();
  }
})();

(function () {
  var PRODUCT_CACHE_PREFIX = 'we_product_ctx_';
  var lastProductViewedKey = '';
  var lastProductViewedAt = 0;

  function publishAnalyticsEvent(eventName, payload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish(eventName, payload);
  }

  function resolveProductViewSection(explicitSection, basePayload) {
    if (explicitSection) {
      return explicitSection;
    }

    if (basePayload && basePayload.section) {
      return basePayload.section;
    }

    var path = window.location.pathname;

    if (path.indexOf('/products/') !== -1) {
      var ref = document.referrer || '';

      try {
        var refUrl = new URL(ref);

        if (refUrl.hostname === window.location.hostname) {
          if (refUrl.pathname.indexOf('/collections/') !== -1) {
            return 'PLP';
          }

          if (refUrl.pathname === '/' || refUrl.pathname === '') {
            return 'Home';
          }
        }
      } catch (error) {
        /* ignore */
      }

      return 'PDP';
    }

    return 'PLP';
  }

  function getCartItemCount(callback) {
    var cartCountNode = document.querySelector('cart-count');

    if (cartCountNode) {
      var domCount = parseInt(String(cartCountNode.textContent || '').trim(), 10);

      if (!isNaN(domCount)) {
        callback(domCount);
        return;
      }
    }

    var root = typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    fetch(root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        callback(Number(cart.item_count) || 0);
      })
      .catch(function () {
        callback(0);
      });
  }

  function buildProductViewedPayload(basePayload, variantId, options) {
    basePayload = basePayload || {};
    options = options || {};

    var variantRow = weFindVariantRow(basePayload.variants, variantId);

    if (!variantRow) {
      variantRow = (basePayload.variants || [])[0] || {};
    }

    var payload = {
      product_id: String(basePayload.product_id || ''),
      shopify_product_id: String(basePayload.shopify_product_id || ''),
      shopify_variant_id: String(variantRow.shopify_variant_id || variantId || ''),
      product_name: basePayload.product_name || '',
      image_url: weNormalizeImageUrl(basePayload.image_url),
      sub_brand_name: basePayload.sub_brand_name || '',
      l1_category_name: basePayload.l1_category_name || '',
      l2_category_name: basePayload.l2_category_name || '',
      l1_category_id: String(basePayload.l1_category_id || ''),
      l2_category_id: String(basePayload.l2_category_id || ''),
      section: resolveProductViewSection(options.section, basePayload),
      view_type: options.view_type || basePayload.view_type || 'normal',
      variant_id: String(variantRow.variant_id || variantId || ''),
      mrp: Number(variantRow.mrp) || 0,
      total_payable: Number(variantRow.total_payable) || 0,
      discount_on_mrp: Number(variantRow.discount_on_mrp) || 0,
      in_stock: !!variantRow.in_stock,
      size: variantRow.size || '',
      color: variantRow.color || basePayload.default_color || '',
      fit: basePayload.fit || '',
      sleeve: basePayload.sleeve || '',
      material: basePayload.material || '',
      gender: basePayload.gender || '',
      total_items_in_cart: Number(options.total_items_in_cart) || 0,
      variants: basePayload.variants || []
    };

    return weApplyBrowseCategoryToProductPayload(payload, options);
  }

  window.__wePublishCategoryViewed = function (menuPayload) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    menuPayload = menuPayload || {};
    var categories = weResolveBrowseCategoryPayload(menuPayload);
    var productCount = menuPayload.product_count;

    if (productCount == null) {
      productCount = (menuPayload.items && menuPayload.items.length) || 0;
    }

    publishAnalyticsEvent('bestseller:category_viewed', {
      l1_category_name: categories.l1_category_name,
      l2_category_name: categories.l2_category_name,
      l1_category_id: categories.l1_category_id,
      l2_category_id: categories.l2_category_id,
      product_count: Number(productCount) || 0,
      name: menuPayload.name,
      id: menuPayload.id,
      items: menuPayload.items
    });
  };

  function shouldSkipProductViewed(payload) {
    var key = String(payload.product_id) + ':' + String(payload.section);
    var now = Date.now();

    if (lastProductViewedKey === key && now - lastProductViewedAt < 2000) {
      return true;
    }

    lastProductViewedKey = key;
    lastProductViewedAt = now;
    return false;
  }

  window.__wePublishProductViewed = function (basePayload, variantId, options) {
    getCartItemCount(function (cartCount) {
      options = options || {};
      options.total_items_in_cart = cartCount;

      var payload = buildProductViewedPayload(basePayload, variantId, options);

      if (shouldSkipProductViewed(payload)) {
        return;
      }

      publishAnalyticsEvent('bestseller:product_viewed', payload);
      weCacheProductContext(payload);
    });
  };

  document.addEventListener(
    'click',
    function (event) {
      var quickBuyButton = event.target.closest('.product-card__quick-add-button');

      if (!quickBuyButton) {
        return;
      }

      var card = quickBuyButton.closest('product-card');

      if (!card) {
        return;
      }

      var analyticsNode = card.querySelector('script.webengage-product-analytics');

      if (!analyticsNode) {
        return;
      }

      try {
        var basePayload = JSON.parse(analyticsNode.textContent || '{}');
        var variants = basePayload.variants || [];
        var variantRow = variants[0] || {};

        window.__wePublishProductViewed(basePayload, variantRow.shopify_variant_id || variantRow.variant_id, {
          section: basePayload.section || 'PLP',
          view_type: 'quick'
        });
      } catch (error) {
        /* ignore */
      }
    },
    true
  );
})();

// -----------------------------------------------------------------------------
// CUSTOMER INVOICE LIST (ONLINE / OFFLINE)
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var invoiceSection = document.querySelector('.invoice-section[data-invoice-endpoint]');
  if (!invoiceSection) return;

  var phone = invoiceSection.getAttribute('data-invoice-phone') || '';
  var store = invoiceSection.getAttribute('data-invoice-store') || '';
  var endpoint = invoiceSection.getAttribute('data-invoice-endpoint') || '';

  if (!phone || !endpoint || !store) return;

  var cache = {
    online: null,
    offline: null
  };
  var currentType = 'online';

  var tabs = invoiceSection.querySelectorAll('.invoice-tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var type = tab.getAttribute('data-invoice-type');
      if (!type || type === currentType) return;

      currentType = type;
      tabs.forEach(function (innerTab) {
        innerTab.classList.toggle('is-active', innerTab === tab);
      });

      loadInvoices(type);
    });
  });

  loadInvoices('online');

  function loadInvoices(type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var errorEl = invoiceSection.querySelector('.invoice-error');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    var table = invoiceSection.querySelector('.invoice-table');
    if (!tbody || !errorEl) return;

    if (table) {
      table.classList.toggle('invoice-table--offline', type === 'offline');
    }

    errorEl.style.display = 'none';
    errorEl.textContent = '';
    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }
    tbody.innerHTML =
      '<tr><td colspan="6">Loading ' + (type === 'online' ? 'website' : 'offline') + ' invoices&hellip;</td></tr>';

    if (cache[type]) {
      renderInvoices(cache[type], type);
      return;
    }

    try {
      var url = new URL(endpoint);
      url.searchParams.set('phone', phone);
      url.searchParams.set('store', store);
      url.searchParams.set('type', type);

      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function (data) {
          if (!data || data.success !== true || !Array.isArray(data.data)) {
            throw new Error('Unexpected API response');
          }

          cache[type] = data.data;
          renderInvoices(cache[type], type);
        })
        .catch(function (error) {
          console.error('Error fetching invoices', error);
          tbody.innerHTML = '';
          errorEl.textContent = 'Unable to load invoices at the moment. Please try again later.';
          errorEl.style.display = 'block';
          if (emptyMessageEl) {
            emptyMessageEl.style.display = 'none';
            emptyMessageEl.textContent = '';
          }
        });
    } catch (e) {
      console.error('Error building invoice URL', e);
    }
  }

  function renderInvoices(list, type) {
    var tbody = invoiceSection.querySelector('.invoice-table-body');
    var emptyMessageEl = invoiceSection.querySelector('.invoice-empty-message');
    if (!tbody) return;

    if (!list || list.length === 0) {
      var message =
        type === 'offline'
          ? 'You do not have any in-store purchases yet.'
          : 'You do not have any online orders yet.';

      tbody.innerHTML = '';

      if (emptyMessageEl) {
        emptyMessageEl.textContent = message;
        emptyMessageEl.style.display = 'block';
      }

      return;
    }

    tbody.innerHTML = '';

    if (emptyMessageEl) {
      emptyMessageEl.style.display = 'none';
      emptyMessageEl.textContent = '';
    }

    list.forEach(function (item) {
      var tr = document.createElement('tr');
      var orderNumber = item.salesOrderNumber || '';
      var invoiceNumber = item.invoiceNumber || '';
      var purchaseDate = formatInvoiceDate(item.purchaseDate);
      var amount = item.paidAmount || '';
      var invoiceDate = formatInvoiceDate(item.invoiceDate);
      var url = item.invoiceUrl || '';

      tr.innerHTML =
        '<td>' + escapeHtml(orderNumber) + '</td>' +
        '<td>' + escapeHtml(invoiceNumber) + '</td>' +
        '<td>' + escapeHtml(purchaseDate) + '</td>' +
        '<td>' + escapeHtml(amount) + '</td>' +
        '<td>' + escapeHtml(invoiceDate) + '</td>' +
        '<td class="text-end">' +
        (url
          ? '<a href="' + encodeURI(url) + '" target="_blank" rel="noopener" class="link-faded">View invoice</a>'
          : '') +
        '</td>';

      tbody.appendChild(tr);
    });
  }

  function formatInvoiceDate(raw) {
    if (!raw) return '';

    var value = String(raw).trim();
    var dotMatch = value.match(/^(\d{2})\.(\d{2})\.(\d{4})/);

    if (dotMatch) {
      return dotMatch[1] + '/' + dotMatch[2] + '/' + dotMatch[3];
    }

    var dashMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (dashMatch) {
      return dashMatch[3] + '/' + dashMatch[2] + '/' + dashMatch[1];
    }

    var d = new Date(value);

    if (!isNaN(d.getTime())) {
      var dd = String(d.getDate()).padStart(2, '0');
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var yyyy = d.getFullYear();
      return dd + '/' + mm + '/' + yyyy;
    }

    return value;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      switch (char) {
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        case '"':
          return '&quot;';
        default:
          return '&#39;';
      }
    });
  }
});
